/*
Origin Core 1.0

called from /layout/theme.liquid

DEVELOPER NOTE
--------------------
any changes to this file should be noted here, and also noted in the following wiki page:
https://unifiedco.atlassian.net/wiki/spaces/ORIGIN/pages/1413414932/Core+File+Changes+1.0

SUMMARY
--------------------
This script enables deferred initialization of Alpine.js components using a custom x-defer attribute. 
It waits for specific triggers—such as user interaction, intersection with the viewport, browser idle time, or custom events—before initializing Alpine components. 
When triggered, it removes x-ignore and calls Alpine.initTree on the element, ensuring Alpine only runs when needed. 
This improves performance by delaying Alpine initialization until the component is likely to be used or visible.

*/

if (document.querySelector('[x-defer]') ) {
    // const deferSelectors = {
    //     ".product-slider section[x-data]": "intersect",
    //     ".product-info [x-data]": "intersect",
    //     "#filters-content [x-data]": "intersect",
    //     "#review_form": "intersect",
    //     "section[x-data^=initRecentlyViewedProductsComponent]": "intersect",
    //     "div[x-data^=initBundleOptions]": "intersect",
    //     "#product_addtocart_form [x-data]": "intersect",
    //     "#notice-cookie-block": "interact"
    // }
    // for (const [selector, deferUntil] of Object.entries(deferSelectors)) {
    //     document.querySelectorAll(selector).forEach(el => el.setAttribute('x-defer', `${deferUntil}`));
    // }

    (function () {
        "use strict";

        const hasAlpine = new Promise(resolve => {
            window.addEventListener('alpine:initialized', resolve, {once: true, passive: true});
        });

        const hasInteract = new Promise(resolve => {
            (events => {
                const onInteract = () => {
                    resolve();
                    events.forEach(type => window.removeEventListener(type, onInteract));
                }
                events.forEach(type => window.addEventListener(type, onInteract, {once: true, passive: true}))
            })(['touchstart', 'wheel', 'mouseover', 'keydown'])
        });

        const onIntersect = (el) => {

            return new Promise(resolve => {
                const observer = new IntersectionObserver(entries => {
                    for (const entry of entries) {
                        if (entry.isIntersecting) {
                            observer.disconnect()
                            resolve();
                            

                        }
                    }
                }, {});
                observer.observe(el);
            });
        }

        function runComponent(el) {
            hasAlpine.then(() => {
                el.removeAttribute('x-ignore');
                queueMicrotask(() => Alpine.initTree(el));
            });
        }

        function initDeferredComponents() {

            document.querySelectorAll('[x-data][x-defer]').forEach(el => {
                el.setAttribute('x-ignore', '');
                const deferUntil = (el.getAttribute('x-defer') || '').trim();
                switch (deferUntil) {
                    case 'interact':
                        hasInteract.then(() => runComponent(el));
                        break;
                    case 'intersect':
                        onIntersect(el).then(() => runComponent(el))
                        break;
                    case 'idle':
                        window.requestIdleCallback(() => runComponent(el), {timeout: 4000})
                        break;
                    case 'eager':
                        runComponent(el);
                        break;
                    default:
                        if (deferUntil.startsWith('event:') && deferUntil.length > 6) {
                            window.addEventListener(deferUntil.substring(6), () => runComponent(el), {once: true, passive: true});
                        }
                }
            });
        }

        window.addEventListener('alpine:init', initDeferredComponents, {once: true, passive: true});
    })()
}

